import "./App.css";
import About from "./cpmponents/About";
import Contact from "./cpmponents/Contact";
import Footer from "./cpmponents/Footer";
import Home from "./cpmponents/Home";
import Navbar from "./cpmponents/Navbar";
import Projects from "./cpmponents/Projects";
import Services from "./cpmponents/Services";
import Skills from "./cpmponents/Skils";

function App() {
  return (
    <div className="App">
      <Navbar />
      <Home />
      <About />
      <Skills />
      <Services />
      <Projects />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
